import { NgModule } from '@angular/core';
import { SelectOptionsComponent } from './select-options.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SelectOptionsComponent],
  exports: [SelectOptionsComponent],
  imports: [CommonModule],
})
export class SelectOptionsModule {
}
